import { HOTEL_CATEGORY_ID, TICKET_CATEGORY_ID } from "app/utils/constant";

export const formatCurrency = (amount) => {
  if (amount === null || amount === undefined) return "₹0";
  return `₹${amount.toLocaleString("en-IN")}`;
};

export const getSoldCount = (variation) => {
  if (typeof variation.sold_count === "object" && variation.sold_count !== null) {
    return variation.sold_count.total_stay || 0;
  }
  return variation.sold_count || 0;
};

export const isHotelProduct = (product) => {
  return product.categories?.some((cat) =>
    cat.category_id === HOTEL_CATEGORY_ID
  );
};

export const isTicketProduct = (product) => {  
  return product.categories?.some((cat) =>
    cat?.category_id === TICKET_CATEGORY_ID
  );
};
